var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShape2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 210,
    viewBox: "0 0 191 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1410097612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M125.53 208.29H118.13L0 12.27V4.57764e-05L125.53 208.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 43.1701L99.93 209.12H0V43.1701Z",
    fill: "#FD6624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M190.33 209.12H138.45L68.9102 93.7301H120.79L190.33 209.12Z",
    fill: "#0B3742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M98.0897 69.1602H72.8097L38.9297 12.9402H64.2097L98.0897 69.1602Z",
    fill: "#FD6624"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape2);
export default __webpack_public_path__ + "static/media/shape-2.dd4ea4515371a6f776c2a4ef9059ea7c.svg";
export { ForwardRef as ReactComponent };